import React, { useState, useEffect, useContext } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Paper, Typography, Tab, Tabs, Button, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiGrid from '@mui/material/Grid';
import { MdAdd } from 'react-icons/md';
import { getWorkflowByClientIdApi } from "../../api's/WorkflowApi";
import { CLIENT_PAGE, WORKFLOW_PAGE } from '../../utils/commonConstants';
import SearchAndFilter from '../../reusable-component/SearchAndFilter';
import ClientNoData from '../../components/Client/ClientNoData';
import WorkflowTable from '../../components/Client/WorkflowTable';
import AddEngagementModal from '../../reusable-component/AddEngagementModal';
import PageHeaderTable from '../../reusable-component/PageHeaderTable';
import AddWorkflowModal from '../../reusable-component/AddWorkflowModal';
import LoadingIcon from '../../reusable-component/LoadingIcon';
import { AuthContext } from '../../context/AuthProvider';
import useDebounce from '../../hooks/useDebounce';
import AccessModal from '../../reusable-component/AccessModal';
import {
  getAllClientByDomainIdApi,
  getClientByUserGroupAndDomainIdApi,
  addClientToFavourite,
  removeClientFromFavourite,
} from "../../api's/ClientApi";
import { DateConverter } from '../../utils/DateConverter';
import PageHeader from '../../reusable-component/PageHeader';
import ClientTable from '../../components/dashboard-component/ClientTable';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function DomainDetails({ headerTableData }) {
  const [mode, setMode] = useState('');
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');
  const [value, setValue] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [workflowTableData, setWorkflowTableData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openWorkflowModal, setOpenWorkflowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openAccessModal, setOpenAccessModal] = useState(false);
  const { userRole, domainId, userGroup } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const [page, setPage] = useState(0);
  const rowsPerPage = 5;
  const [totalCount, setTotalCount] = useState(0);
  const [totalText, setTotalText] = useState(0);
  const debouncedSearch = useDebounce(search, 500);

  const toggleFavoriteClient = async (clientId) => {
    if (userRole === 'READER') {
      enqueueSnackbar('You have only Read Permission !!', {
        variant: 'error',
      });
      return;
    }
    setLoading(true);
    try {
      const selectedClient = tableData.find((client) => client.client_id === clientId);
      const isFavorite = selectedClient?.is_fav || false;
      const apiCall = isFavorite ? removeClientFromFavourite : addClientToFavourite;

      const response = await apiCall(clientId);
      if (response.status === 200) {
        const updatedTableData = tableData.map((client) =>
          client.client_id === clientId ? { ...client, is_fav: !isFavorite } : client
        );

        setTableData(updatedTableData);

        enqueueSnackbar(isFavorite ? 'Removed from favorites' : 'Added to favorites', {
          variant: 'success',
        });
      }
    } catch (error) {
      console.error(error);
      if (error.response?.status === 403) {
        enqueueSnackbar('You have only Read Permission !!', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('Failed to update favorites', {
          variant: 'error',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleWorkflowModal = () => {
    if (userRole === 'READER') {
      handleAccessModal();
    } else {
      setOpenWorkflowModal(!openWorkflowModal);
    }
  };

  const handleSearch = () => {
    console.log('Hii');
  };

  const handleMode = (event) => {
    setMode(event.target.value);
  };

  const handleStatus = (event) => {
    sessionStorage.setItem('filtered_domaindetails_status', event.target.value);
    setStatus(event.target.value);
  };

  const handleOnChange = (event) => {
    sessionStorage.setItem('filtered_domaindetails_search', event.target.value);
    setSearch(event.target.value);
  };

  const handleClearFilter = () => {
    sessionStorage.removeItem('filtered_domaindetails_status');
    sessionStorage.removeItem('filtered_domaindetails_search');

    setMode('');
    setStatus('');
    setSearch('');
    setPage(0);
  };

  const handleAccessModal = () => {
    setOpenAccessModal(!openAccessModal);
  };

  const fetchTableData = async (pageNo = page) => {
    setLoading(true);
    try {
      const response =
        userRole === 'SUPER_USER'
          ? await getAllClientByDomainIdApi(domainId)
          : await getClientByUserGroupAndDomainIdApi(
              headerTableData.domain_id,
              pageNo,
              rowsPerPage,
              debouncedSearch,
              status
            );

      if (response.status === 200) {
        setTableData(response.data.data);
        if (search === '' && status === '') setTotalText(response.data.totalData);
        setTotalCount(response.data.totalData);
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', { variant: 'error' });
      } else if (error.response?.status === 404) {
        setTableData([]);
        enqueueSnackbar('404 Client not found!', { variant: 'error' });
      } else {
        enqueueSnackbar('Something went wrong!', { variant: 'error' });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    if (!domainId && !headerTableData?.domain_id) return;

    setPage(0);
  }, [domainId, headerTableData?.domain_id]);
  useEffect(() => {
    if (!domainId && !headerTableData?.domain_id) return;
    fetchTableData(page);
  }, [page, headerTableData?.domain_id, debouncedSearch, status]);

  const version = JSON.parse(sessionStorage.getItem('version'));

  const fetchWorkflowTableData = async () => {
    setLoading(true);
    const response = await getWorkflowByClientIdApi(headerTableData.client_id);
    try {
      if (response.status === 200) {
        if (version === '1.0') {
          const filterByVersion = response.data.filter(
            (item) => item.process_type === 'Data Ingestion' || item.process_type === 'Data Transformation'
          );
          setWorkflowTableData(filterByVersion);
        } else {
          setWorkflowTableData(response.data);
        }
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', {
          variant: 'error',
        });
      } else if (error.response?.status === 404) {
        enqueueSnackbar('404 Workflow not found!', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const Grid = styled(MuiGrid)(({ theme }) => ({
    width: '100%',
    ...theme.typography.body1,
    '& [role="separator"]': {
      margin: theme.spacing(0, 2),
    },
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setMode('');
    setStatus('');
    setSearch('');
  };

  const data = {
    search,
    handleSearch,
    handleOnChange,
    region: mode,
    handleRegion: handleMode,
    handleClearFilter,
    handleStatus,
    status,
    firstFilterText: CLIENT_PAGE.clientFilterByMode,
    secondFilterText: CLIENT_PAGE.clientFilterByStatus,
    clearFilterText: CLIENT_PAGE.clientClearFilterButton,
    firstFilterValues: {
      first: 'Real Time',
      second: 'Batch',
    },
    secondFilterValues: {
      filterData: ['approved', 'pending', 'rejected'],
    },
    isFirstFilterVisible: value === 1,
    isSecondFilterVisible: true,
    isThirdFilterVisible: false,
  };

  const headerData = {
    firstHeader: 'DOMAIN',
    secondHeader: 'TOTAL CLIENT',
    thirdHeader: 'CREATED BY',
    fourthHeader: 'CREATED ON',
    fifthHeader: 'STATUS',
    firstHeaderText: headerTableData.domain_name,
    secondHeaderText: totalText,
    // secondHeaderText: headerTableData.client_count,
    thirdHeaderText: 'Depadmin',
    fourthHeaderText: DateConverter(headerTableData.creation_date),
    fifthHeaderText: headerTableData.status,
    route: '/domain',
  };

  return (
    <Box>
      <PageHeaderTable data={headerData} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#47D7AC',
            },
          }}
          sx={{ '& .MuiTab-root.Mui-selected': { color: '#00043C' } }}
        >
          <Tab label={`Clients(${totalText})`} {...a11yProps(0)} sx={{ fontWeight: 'bold' }} />
        </Tabs>
      </Box>
      <Box>
        <TabPanel value={value} index={0}>
          <PageHeader
            title={CLIENT_PAGE.clientPageTitle}
            btnText={CLIENT_PAGE.addNewClientButton}
            route="/client/onboarding"
          />
          <SearchAndFilter data={data} />
          {tableData.length !== 0 ? (
            <ClientTable
              search={search}
              totalCount={totalCount}
              tableData={tableData}
              fetchTableData={fetchTableData}
              handleChangePage={handleChangePage}
              currentPage={page}
              toggleFavoriteClient={toggleFavoriteClient}
            />
          ) : (
            !loading && (
              <Paper elevation={3} sx={{ height: '350px', marginTop: '15px' }}>
                <ClientNoData title={CLIENT_PAGE.clientPageNoDataToDisplay} text={CLIENT_PAGE.noClientToReview} />
              </Paper>
            )
          )}
          {loading && <LoadingIcon />}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid container direction="row" display="flex">
            <Grid item xs={6} direction="row" justifyContent="flex-start" style={{ color: '#43425D' }}>
              {WORKFLOW_PAGE.workflowPageTitle}
            </Grid>
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: '#00043C', '&:hover': { backgroundColor: '#00043C' } }}
                onClick={handleWorkflowModal}
              >
                <MdAdd />
                Add New Workflow
              </Button>
            </Grid>
          </Grid>
          <AddWorkflowModal
            handleModal={handleWorkflowModal}
            open={openWorkflowModal}
            fetchTableData={fetchWorkflowTableData}
            processType="Ingestion"
          />
          {workflowTableData.length > 0 && <SearchAndFilter data={data} />}
          {workflowTableData.length !== 0 ? (
            <WorkflowTable
              tableData={workflowTableData}
              search={search}
              fetchWorkflowTableData={fetchWorkflowTableData}
            />
          ) : (
            <Paper elevation={3} sx={{ height: '330px', marginTop: '10px' }}>
              <ClientNoData
                title={WORKFLOW_PAGE.workflowPageNoDataToDisplay}
                text={WORKFLOW_PAGE.noWorkflowToReview}
                addBtnText={WORKFLOW_PAGE.addNewWorkflowButton}
                handleOnClick={handleWorkflowModal}
                isAddBtn
              />
            </Paper>
          )}
          {loading && <LoadingIcon />}
        </TabPanel>
        <AddEngagementModal handleCloseModal={handleCloseModal} openModal={openModal} fetchData={fetchTableData} />
        <AccessModal openAccessModal={openAccessModal} handleAccessModal={handleAccessModal} />
      </Box>
    </Box>
  );
}
